import React, { useState, useEffect } from 'react';
import { DrawingCanvas, DrawingControls } from '.';
import './Artboard.scss';

const colourOptions = [
  {
    label: 'Green',
    hex: '#00BC74',
  },
  {
    label: 'Orange',
    hex: '#FF6C13',
  },
  {
    label: 'Blue',
    hex: '#0A85E5',
  },
];

const ESC_KEY_CODE = 'Escape';

const Artboard = (props) => {
  const {
    width,
    height,
    inView,
  } = props;
  const [lines, setLines] = useState([]);
  const [isDrawing, setDrawing] = useState(false);
  const [currentStroke, setCurrentStroke] = useState(colourOptions[0]);
  const keyPressHandler = ({ key }) => {
    // Set drawing to false if user presses the 'escape' key
    if (key === ESC_KEY_CODE && isDrawing) {
      setDrawing(false);
    }
  };
  const clearArtboard = (event) => {
    if (event) event.preventDefault();
    setDrawing(false);
    setLines([]);
  };
  useEffect(() => {
    window.addEventListener('keydown', keyPressHandler);
    if (!inView && isDrawing) setDrawing(false);
    return () => {
      window.removeEventListener('keydown', keyPressHandler);
    };
  }, [isDrawing, inView]);
  return (
    <div className={`artboard${isDrawing ? ' drawing-active' : ''}`}>
      <DrawingControls
        hasDrawn={lines && lines.length > 0}
        clearArtboard={clearArtboard}
        isDrawing={isDrawing}
        setDrawing={setDrawing}
        currentStroke={currentStroke}
        setCurrentStroke={setCurrentStroke}
        colourOptions={colourOptions}
        inView={inView}
      />
      <DrawingCanvas
        isDrawing={isDrawing}
        currentStroke={currentStroke}
        height={height}
        width={width}
        lines={lines}
        setLines={setLines}
      />
    </div>
  );
};

export default Artboard;
